/**
 * Application constants
 */

// API Configuration
export const API_URL = process.env.REACT_APP_API_URL || 'https://ordercoffee.uk/.netlify/functions/get-curated-products';

// UI Constants
export const STICKY_HEADER_THRESHOLD = 50; // pixels - scroll distance before header shrinks
export const HEADER_HEIGHT_OFFSET = 80; // pixels - offset for smooth scroll to account for sticky header

// Fallback menu data (used if API fails)
export const FALLBACK_MENU_ITEMS = [
  { name: 'Flat White', price: '£3.90' },
  { name: 'Latte', price: '£4.10' },
  { name: 'Cappuccino', price: '£4.00' },
  { name: 'Americano', price: '£3.50' },
  { name: 'Espresso', price: '£3.30' },
  { name: 'Mocha', price: '£4.40' },
  { name: 'Cortado', price: '£3.80' },
  { name: 'Short Black', price: '£3.30' },
  { name: 'Chai Latte', price: '£4.50' },
  { name: 'Matcha Latte', price: '£4.80' },
  { name: 'Hot Chocolate', price: '£4.20' }
];

// Menu item names to filter from API
export const MENU_ITEM_NAMES = [
  'Flat White',
  'Latte',
  'Cappuccino',
  'Americano',
  'Espresso',
  'Mocha',
  'Cortado',
  'Short Black',
  'Chai Latte',
  'Matcha Latte',
  'Hot Chocolate'
];
